import React from 'react';
import { observer } from 'mobx-react-lite';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_BOX, CARDS_TYPE_BETSHOP } from '../../enums/cardTypes';
import { IDS } from '../../enums/constants';
import { winningAmountStore } from '../../store/winningAmountStore';
import { ROUND_BET_TYPE_VIEW } from '../../enums/betTypesEnum';

export const BetShopPlayerCards = observer(() => {
  const { playerCards } = cardsStore;
  const { winType } = winningAmountStore;

  return (
    <div
      className={`bb-cards bb-left-deck ${
        winType !== null && winType === ROUND_BET_TYPE_VIEW.BANKER ? 'disabled' : ''
      }`}
    >
      {CARDS_BOX.map((item, index) => {
        const card = playerCards.length > index ? playerCards[index] : null;
        return (
          <div className='bb-card-holder' key={IDS[index]}>
            <div className={`bb-card ${Number.isInteger(card?.card) ? 'open' : ''}`}>
              <div className={`bb-card-front ${CARDS_TYPE_BETSHOP[card?.card]}`} />
              <div className='bb-card-back' />
            </div>
          </div>
        );
      })}
    </div>
  );
});
